import axios from 'axios'
import { ASSET_PATH } from 'common_packages/assets/js/api/assets'

type PuzzleData = {
  PuzzleId: string
  PuzzleType: string
  PuzzleUrl: string
  Width: number
  Height: number
  X: number
  Y: number
}

type PageData = {
  PageNr: number
  ImageUrl: string
  Width: number
  Height: number
  Puzzles: PuzzleData[]
}

type MagazineMetaData = {
  PortalName: string
  ContentFolder: string
  Pages: PageData[]
}

export const getPackMetadata = async (
  clientId: string,
  puzzlePackName: string,
  abortController: AbortController,
): Promise<MagazineMetaData> => {
  try {
    const res = await axios.get(`${ASSET_PATH}/Content/GetPackMetadata?clientId=${clientId}&packName=${puzzlePackName}`, {
      signal: abortController.signal,
    })
    if (res?.data?.Pages?.length) {
      return res.data
    }
    return null
  } catch (error) {
    throw new Error('Error getting e-magazine metadata')
  }
}
